/* =============================================================================
   RIDBOI MONOCHROME — PRODUCT PAGE (Shopify build)
   Variant selection from Shopify options → price/availability/buy state/URL/
   variant image switching. Add to Cart posts the selected variant to the
   Shopify cart (via cart.js). No hardcoded product data.
   ============================================================================ */
(function () {
  'use strict';

  /* =====================================================================
     GALLERY (self-contained, attached first, cannot be killed by anything
     below): thumbnail taps via document-level delegation + swipe and
     tap-to-cycle on the main image.
     ==================================================================== */
  (function gallery() {
    try {
      var slider = document.getElementById('pdpSlider');
      if (!slider) return;
      var thumbBar = document.getElementById('pdpSliderThumb');

      function allSlides() { return Array.prototype.slice.call(slider.querySelectorAll('.pdp-slide')); }
      function visibleSlides() { return allSlides().filter(function (s) { return s.style.display !== 'none'; }); }
      function allThumbs() { return Array.prototype.slice.call(document.querySelectorAll('.pdp-thumb')); }

      /* Slides now peek (≈88% wide + gap), so the step is the slide's own width, not the viewport. */
      function slideStep() {
        /* must measure a VISIBLE slide: a filtered-out one has zero width,
           which used to give a nonsense step and scroll the gallery to blank */
        var s = visibleSlides()[0] || slider.querySelector('.pdp-slide');
        if (!s) return slider.clientWidth || 1;
        var st = getComputedStyle(slider);
        var gap = parseFloat(st.columnGap || st.gap || 0) || 0;
        return s.getBoundingClientRect().width + gap;
      }
      function activeIndex() {
        var step = slideStep();
        if (!step) return 0;
        return Math.round(slider.scrollLeft / step);
      }

      /* Progress bar segment + thumbnail highlight follow the scroll position. */
      function updateBar() {
        var vis = visibleSlides();
        var n = vis.length;
        if (thumbBar && n > 0) {
          thumbBar.style.width = (100 / n) + '%';
          thumbBar.style.transform = 'translateX(' + (Math.min(activeIndex(), n - 1) * 100) + '%)';
        }
        var current = vis[Math.min(activeIndex(), n - 1)];
        var mid = current && current.getAttribute('data-media-id');
        allThumbs().forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-media-id') === mid);
        });
      }

      function scrollToIndex(i) {
        slider.scrollTo({ left: i * slideStep(), behavior: 'smooth' });
      }

      var raf;
      slider.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateBar);
      }, { passive: true });
      window.addEventListener('resize', updateBar);

      /* Thumbnail click scrolls the slider to that image. */
      document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('.pdp-thumb');
        if (!t) return;
        var mid = t.getAttribute('data-media-id');
        var vis = visibleSlides();
        for (var i = 0; i < vis.length; i++) {
          if (vis[i].getAttribute('data-media-id') === mid) { scrollToIndex(i); break; }
        }
      });

      /* Show only the chosen colour's shots.
         Preferred source is the variant image assignments made in Shopify admin
         (window.RBC_COLOUR_MEDIA); falls back to the alt-text convention; and if
         neither identifies anything, every image stays visible so nothing breaks. */
      window.RBC_GALLERY_COLOR = function (color) {
        var raw = color || '';
        color = raw.toLowerCase();
        var all = allSlides();
        var matching = [];

        var map = window.RBC_COLOUR_MEDIA;
        if (map) {
          var ids = map[raw] || map[color];
          if (!ids) {                                   // case-insensitive lookup
            for (var k in map) {
              if (k.toLowerCase() === color) { ids = map[k]; break; }
            }
          }
          if (ids && ids.length) {
            var wanted = {};
            for (var i = 0; i < ids.length; i++) wanted[String(ids[i])] = 1;
            matching = all.filter(function (s) {
              return wanted[String(s.getAttribute('data-media-id'))];
            });
          }
        }
        if (!matching.length) {                         // alt-text fallback
          matching = all.filter(function (s) { return color && s.getAttribute('data-color') === color; });
        }
        var show = matching.length ? matching : all;
        all.forEach(function (s) { s.style.display = (show.indexOf(s) > -1) ? '' : 'none'; });
        allThumbs().forEach(function (t) {
          var mid = t.getAttribute('data-media-id');
          var on = show.some(function (s) { return s.getAttribute('data-media-id') === mid; });
          t.style.display = on ? '' : 'none';
        });
        slider.scrollLeft = 0;
        requestAnimationFrame(function () { slider.scrollLeft = 0; updateBar(); });
        updateBar();
      };

      /* Variant logic asks the gallery to land on a variant's featured image. */
      window.RBC_GALLERY_SHOW = function (media) {
        if (!media) return;
        var vis = visibleSlides();
        for (var i = 0; i < vis.length; i++) {
          if (String(vis[i].getAttribute('data-media-id')) === String(media.id)) { scrollToIndex(i); return; }
        }
      };

      updateBar();
    } catch (err) { /* gallery must never take the page down */ }
  })();

  var dataEl = document.getElementById('productData');
  var root = document.querySelector('[data-product]');
  if (!dataEl || !root) return;

  var data;
  try { data = JSON.parse(dataEl.textContent); }
  catch (e) { data = { variants: [], options: [], mediaMap: {}, inventory: {} }; }
  /* colour -> [media ids], built in Liquid from the variant image assignments */
  window.RBC_COLOUR_MEDIA = data.colourMedia || null;
  var variants = data.variants;
  var mediaMap = data.mediaMap || {};
  var optionCount = (data.options || []).length;

  var variantInput = document.getElementById('variantId');
  var priceEl = document.getElementById('pdpPrice');
  var stickyPrice = document.getElementById('stickyPrice');
  var availEl = document.getElementById('pdpAvail');
  var availText = availEl && availEl.querySelector('[data-avail-text]');
  var buyBtn = document.getElementById('buyButton');
  var stickyBtn = document.getElementById('stickyAdd');
  var mainStage = document.getElementById('pdpMain');
  var form = document.getElementById('productForm');
  var qtyVal = document.getElementById('qtyVal');
  var qtyInput = document.getElementById('qtyInput');
  var qtyNote = document.getElementById('qtyNote');
  var oosNote = document.getElementById('sizeOOSNote');
  var payWrap = root.querySelector('.shopify-payment-button');

  /* Shopify's own Buy it now button doesn't know about our variant switching,
     so it stays live on a sold-out size and drops the shopper into a failing
     checkout. Take it off screen whenever the size can't actually be bought. */
  function setPayVisible(on) {
    if (!payWrap) return;
    payWrap.style.display = on ? '' : 'none';
    var inner = payWrap.querySelector('button');
    if (inner) inner.disabled = !on;
  }
  var noteTimer = null;
  var maxQty = 10;                 // recalculated per variant from real stock
  var setQty = function () {};     // assigned by the quantity module below

  /* Which option is colour, which is size (sparse matrices need both) */
  var colorIdx = -1, sizeIdx = -1;
  (data.options || []).forEach(function (n, i) {
    if (/colou?r/i.test(n)) colorIdx = i;
    if (/^size$/i.test(n)) sizeIdx = i;
  });

  /* current selection: one value per option index, seeded from .is-active */
  var selected = [];
  root.querySelectorAll('.opt-group').forEach(function (group) {
    var idx = parseInt(group.getAttribute('data-option-index'), 10);
    var active = group.querySelector('[data-option-btn].is-active');
    selected[idx] = active ? active.getAttribute('data-value') : null;
  });

  /* Sizes actually offered in a given colour. Not every colour carries every
     size, so the size row has to follow the colour. */
  function sizesForColour(colour) {
    /* Two different things, and they must look different to the shopper:
         exists  - we make this size in this colour
         inStock - we have it right now
       A size we don't make is hidden. A size that's merely sold out stays
       visible and greyed, so people know it exists and can come back. */
    var exists = {}, inStock = {};
    variants.forEach(function (v) {
      if (colorIdx > -1 && v.options[colorIdx] !== colour) return;
      if (sizeIdx < 0) return;
      var sz = v.options[sizeIdx];
      exists[sz] = 1;
      if (v.available) inStock[sz] = 1;
    });
    return { exists: exists, inStock: inStock };
  }

  function syncSizes() {
    if (sizeIdx < 0) return;
    var group = root.querySelector('.opt-group[data-option-index="' + sizeIdx + '"]');
    if (!group) return;
    var map = sizesForColour(selected[colorIdx]);
    var btns = Array.prototype.slice.call(group.querySelectorAll('[data-option-btn]'));
    var firstValid = null;
    btns.forEach(function (b) {
      var sz = b.getAttribute('data-value');
      var made = !!map.exists[sz], have = !!map.inStock[sz];
      b.hidden = !made;                     // not made in this colour -> gone
      b.classList.toggle('is-oos', made && !have);   // made but sold out -> greyed
      b.setAttribute('aria-disabled', made && !have ? 'true' : 'false');
      if (have && !firstValid) firstValid = b;
    });
    /* only jump if the size isn't made here at all; a sold-out size stays
       selected so the shopper sees it's out of stock rather than it vanishing */
    if (!map.exists[selected[sizeIdx]] && firstValid) {
      selected[sizeIdx] = firstValid.getAttribute('data-value');
      btns.forEach(function (b) {
        var on = b === firstValid;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var ve = group.querySelector('[data-option-value]');
      if (ve) ve.textContent = selected[sizeIdx];
    }
  }

  function findVariant() {
    if (!optionCount) return variants[0];
    return variants.find(function (v) {
      for (var i = 0; i < optionCount; i++) {
        if (v.options[i] !== selected[i]) return false;
      }
      return true;
    }) || null;
  }

  function formatMoney(cents) {
    var format = (window.RBC && window.RBC.moneyFormat) || '₦{{amount}}';
    var amount = (cents / 100).toLocaleString('en-NG', { minimumFractionDigits: 0 });
    return format.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }


  var scarcityEl = document.getElementById('pdpScarcity');
  var buyLabel = document.querySelector('[data-buy-label]');
  var buyPrice = document.querySelector('[data-buy-price]');

  var lastColor = null;    // tracks the colour so size changes don't touch the gallery
  var firstPaint = true;

  function paint() {
    var variant = findVariant();
    var strings = (window.RBC && window.RBC.strings) || {};
    if (variant) {
      variantInput.value = variant.id;
      if (priceEl) priceEl.innerHTML = variant.compare_at_price > variant.price
        ? '<span class="price__sale">' + formatMoney(variant.price) + '</span> <s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s>'
        : formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var ok = variant.available;
      /* Cap the quantity picker at this variant's real stock. Untracked stock
         (null) keeps a sane UI ceiling of 10. */
      var stockN = (data.inventory || {})[String(variant.id)];
      maxQty = (typeof stockN === 'number' && stockN > 0) ? Math.min(stockN, 10) : 10;
      setQty(parseInt(qtyVal ? qtyVal.textContent : '1', 10));
      [buyBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = !ok; });
      var label = ok ? (strings.addToCart || 'Add to Cart') : (strings.soldOut || 'Sold Out');
      if (buyLabel) buyLabel.textContent = label;
      if (buyPrice) buyPrice.textContent = formatMoney(variant.price);
      if (stickyBtn) stickyBtn.textContent = label;
      // scarcity ("Only X left in stock")
      if (scarcityEl) {
        var qty = (data.inventory || {})[String(variant.id)];
        var thr = data.scarcityThreshold || 0;
        if (ok && thr > 0 && typeof qty === 'number' && qty > 0 && qty <= thr) {
          scarcityEl.textContent = 'Only ' + qty + ' left in stock';
          scarcityEl.hidden = false;
        } else { scarcityEl.hidden = true; }
      }
      if (availEl) {
        availEl.classList.toggle('is-in', ok);
        availEl.classList.toggle('is-out', !ok);
        if (availText) availText.textContent = ok ? 'In stock' : (strings.soldOut || 'Sold Out');
      }
      setPayVisible(ok);
      /* Say plainly which size sold out, right under the size pills */
      if (oosNote) {
        if (!ok && sizeIdx > -1 && selected[sizeIdx]) {
          oosNote.textContent = 'Size ' + selected[sizeIdx] + ' is out of stock right now. Pick another size or check back soon.';
          oosNote.hidden = false;
        } else { oosNote.hidden = true; }
      }
      // Only the COLOUR drives the gallery. Changing size (or any other option)
      // must not move or reload the images.
      var colorIdx = -1;
      (data.options || []).forEach(function (name, i) { if (/colou?r/i.test(name)) colorIdx = i; });
      var curColor = colorIdx > -1 ? selected[colorIdx] : null;
      if (curColor !== lastColor) {
        var colorChanged = !firstPaint;         // false on initial load, true on a real change
        lastColor = curColor;
        if (colorIdx > -1 && window.RBC_GALLERY_COLOR) window.RBC_GALLERY_COLOR(curColor);
        if (colorChanged) {
          var media = mediaMap[String(variant.id)];
          if (media && window.RBC_GALLERY_SHOW) window.RBC_GALLERY_SHOW(media);
        }
      }
      // keep the URL shareable
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.href);
      }
    } else {
      [buyBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = true; });
      if (buyLabel) buyLabel.textContent = strings.unavailable || 'Unavailable';
      if (stickyBtn) stickyBtn.textContent = strings.unavailable || 'Unavailable';
      if (scarcityEl) scarcityEl.hidden = true;
      if (oosNote) oosNote.hidden = true;
      setPayVisible(false);
      if (availEl) { availEl.classList.remove('is-in'); availEl.classList.add('is-out');
        if (availText) availText.textContent = strings.unavailable || 'Unavailable'; }
    }
    firstPaint = false;
  }

  /* option buttons */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-option-btn]');
    if (!btn) return;
    var group = btn.closest('.opt-group');
    var idx = parseInt(group.getAttribute('data-option-index'), 10);
    selected[idx] = btn.getAttribute('data-value');
    group.querySelectorAll('[data-option-btn]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var valueEl = group.querySelector('[data-option-value]');
    if (valueEl) valueEl.textContent = selected[idx];
    if (idx === colorIdx) syncSizes();
    paint();
  });



  /* quantity — never lets the shopper pick more than we actually have */
  (function () {
    var minus = root.querySelector('[data-qty-minus]');
    var plus = root.querySelector('[data-qty-plus]');
    function set(n, userTried) {
      if (isNaN(n)) n = 1;
      var capped = n > maxQty;
      n = Math.max(1, Math.min(maxQty, n));
      qtyVal.textContent = n;
      qtyInput.value = n;
      if (plus) plus.disabled = n >= maxQty;
      if (minus) minus.disabled = n <= 1;

      if (qtyNote) {
        if (userTried && capped) {
          /* they pushed past the ceiling: say why, and keep it on screen briefly */
          qtyNote.textContent = 'Only ' + maxQty + ' left in this size';
          qtyNote.hidden = false;
          qtyNote.classList.add('is-flash');
          clearTimeout(noteTimer);
          noteTimer = setTimeout(function () { qtyNote.classList.remove('is-flash'); }, 900);
        } else if (n >= maxQty && maxQty < 10) {
          /* sitting at the ceiling: quiet standing note */
          qtyNote.textContent = 'Only ' + maxQty + ' left in this size';
          qtyNote.hidden = false;
        } else {
          qtyNote.hidden = true;
        }
      }
    }
    setQty = set;                                  // variant logic re-clamps through this
    if (minus) minus.addEventListener('click', function () { set(parseInt(qtyVal.textContent, 10) - 1); });
    if (plus) plus.addEventListener('click', function () { set(parseInt(qtyVal.textContent, 10) + 1, true); });
  })();

  /* add to cart → Shopify cart drawer (cart.js) */
  function submitToCart() {
    var fd = new FormData(form);
    document.dispatchEvent(new CustomEvent('rbc:cart:add', { detail: { formData: fd } }));
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submitToCart(); });
  if (stickyBtn) stickyBtn.addEventListener('click', submitToCart);

  /* wishlist heart (V1 behaviour: visual toggle) */
  var wishBtn = document.getElementById('pdpWish');
  if (wishBtn) wishBtn.addEventListener('click', function () {
    var on = wishBtn.classList.toggle('is-active');
    wishBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
  });

  syncSizes();
  paint();
})();
